/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Fact_SizeInputs */

const en_mk_sol_fact_size = /** @type {(inputs: Mk_Sol_Fact_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team size`)
};

const id_mk_sol_fact_size = /** @type {(inputs: Mk_Sol_Fact_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran tim`)
};

/**
* | output |
* | --- |
* | "Team size" |
*
* @param {Mk_Sol_Fact_SizeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_fact_size = /** @type {((inputs?: Mk_Sol_Fact_SizeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Fact_SizeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_fact_size(inputs)
	return en_mk_sol_fact_size(inputs)
});